import { createApiClient } from '@rolefit/shared/react';

// In dev, Vite proxies /api to the Fastify server, so a relative baseURL keeps
// cookies same-origin. In prod, set VITE_API_URL to the API origin.
const baseURL = import.meta.env.VITE_API_URL ?? '';

export const api = createApiClient({ baseURL });
